import axios from "axios";
import React, { useState, useContext, useEffect, useMemo } from "react";
import AuthContext from "../../context/AuthProvider";
import Globals from "../../parameter/globals";
import Loading from "../../components/Loading";
import { GlobalFilter } from "../../components/globalFilter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  setGlobalFilter,
  usePagination,
} from "react-table";
import { Card } from "react-bootstrap";

import moment from "moment/moment";
import "moment/locale/it";

import AdminNav from "../../components/AdminNav";

function ArchiveEventsRegistration() {
  //dichiara variabili di event
  const [events, setEvents] = useState([]);

  //variabili server, error
  const { auth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const navigate = useNavigate();

  //chiamata di visualizzazione eventi, con conteggio iscritti

  const getEvents = async () => {
    try {
      setLoading(true);
      let body = {
        access_token: auth.accessToken,
      };

      let formdata = new FormData();

      formdata.append("body", JSON.stringify(body));

      const response = await axios.post(Globals.ADMINGETEVENTS, formdata, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });

      if (response?.data?.error === true) {
        setLoading(false);
        setErrMsg(response?.data?.message);
      } else {
        setLoading(false);
        setEvents(response?.data?.events);
      }
    } catch (err) {
      setLoading(false);
      setErrMsg(err);
    }
  };

  const tableHooks = (hooks) => {
    hooks.visibleColumns.push((columns) => [...columns]);
  };

  const eventsData = useMemo(() => [...events], [events]);

  const eventsColumns = useMemo(
    () =>
      events[0]
        ? Object.keys(events[0])
            .filter((key) => key !== "id")
            .map((key) => {
              if (key === "immagine")
                return {
                  Header: "",
                  accessor: key,
                  Cell: ({ value }) => (
                    <img src={value} height={"150px"} width={"150px"} />
                  ),
                };

              if (key === "Data inizio")
                return {
                  Header: "Inizio",
                  accessor: key,
                  Cell: ({ value }) => (
                    <span> {moment(value).format("DD MMMM YYYY")}</span>
                  ),
                };

              if (key === "Data fine")
                return {
                  Header: "Fine",
                  accessor: key,
                  Cell: ({ value }) => (
                    <span> {moment(value).format("DD MMMM YYYY")}</span>
                  ),
                };

              return { Header: key, accessor: key };
            })
        : [],
    [events]
  );

  const tableInstance = useTable(
    {
      columns: eventsColumns,
      data: eventsData,
      initialState: { pageIndex: 0, pageSize: 25 },
    },
    useGlobalFilter,
    tableHooks,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    preGlobalFilteredRows,
    setGlobalFilter,
    state,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    page,
  } = tableInstance;
  const { pageIndex, pageSize } = state;

  useEffect(() => {
    getEvents();
  }, []);

  //dichiarazione tabella di visualizzazione degli event con annesso hover

  if (loading) {
    return <Loading />;
  } else {
    return (
      <div
        className="container"
        style={{ marginTop: "140px", marginBottom: "100px" }}
      >
        <AdminNav />
        {/* <h2 className=" text-center uppercase" style={{fontSize:"50px"}}> Gestione iscrizione eventi </h2> */}
        <div>
          {/* <Button onClick={() => navigate(-1)}>
						<span> Torna indietro</span>
					</Button> */}

          {/* <h2> Gestione iscrizione eventi </h2> */}
          {/* <h3> Scegli Evento</h3> */}
          {/* <Button onClick={() => NewModal()}> Inserisci Nuovo Ordine </Button> */}
        </div>
        <GlobalFilter
          preGlobalFilteredRows={preGlobalFilteredRows}
          setGlobalFilter={setGlobalFilter}
          globalFilter={state.globalFilter}
        />

        <Table
          {...getTableProps()}
          striped
          bordered
          hover
          responsive
          variant="light"
        >
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    style={{
                      borderBottom: "solid 3px ",
                      color: "black",
                      fontWeight: "bold",
                      fontSize: "20px",
                      textTransform: "capitalize",
                    }}
                  >
                    {column.render("Header")}
                    {column.isSorted ? (column.isSortedDesc ? " ▼" : " ▲") : ""}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);

              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td
                        {...cell.getCellProps()}
                        style={{
                          padding: "5px",
                          border: "solid 1px gray",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          navigate("/eventsSubscribeList/" + row.original.id, {
                            state: { name: row.original.Nome },
                          })
                        }
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
        <Card>
          <div className="responsive-pagination">
            <div>
              <button
                className="btn btn-light"
                onClick={() => gotoPage(0)}
                disabled={!canPreviousPage}
              >
                {"<<"}
              </button>{" "}
              <button
                className="btn btn-light mx-1"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                Precedente
              </button>{" "}
              <button
                className="btn btn-light mx-1"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                Successiva
              </button>{" "}
              <button
                onClick={() => gotoPage(pageCount - 1)}
                disabled={!canNextPage}
                className="btn btn-light mx-1"
              >
                {">>"}
              </button>{" "}
            </div>
            <div className="float-end">
              <span className="w-100">
                Pagina:{" "}
                <strong>
                  {pageIndex + 1} di {pageOptions.length}
                </strong>{" "}
              </span>
            </div>
            <div className="text-center">
              <span>
                Vai alla pagina{" "}
                <input
                  type="number"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    const pageNumber = e.target.value
                      ? Number(e.target.value) - 1
                      : 0;
                    gotoPage(pageNumber);
                  }}
                  className="d-flex justify-content-center mx-auto responsive-pagination"
                />
              </span>{" "}
            </div>
            <select
              className="form-select form-select-sm mt-4 w-25 mx-auto responsive-pagination"
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
            >
              {[10, 25, 50, 75].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Visualizza {pageSize} righe
                </option>
              ))}
            </select>
          </div>
        </Card>
        {errMsg && <p className="fs-1 fw-bolder danger"> {errMsg}</p>}
      </div>
    );
  }
}

export default ArchiveEventsRegistration;
